export default __webpack_public_path__ + "static/media/Compute_WD+.60e76093.svg";